/* Recent bekeken producten via localStorage. Registreert het huidige product
   en toont eerder bekeken producten (lichtgewicht, via /products/<handle>.js). */
class SkRecentProducts extends HTMLElement {
  connectedCallback() {
    this.KEY = 'sk_recently_viewed';
    this.current = this.dataset.current || '';
    this.limit = parseInt(this.dataset.limit, 10) || 4;
    this.grid = this.querySelector('[data-recent-grid]');
    this.render();
  }

  read() {
    try { return JSON.parse(localStorage.getItem(this.KEY) || '[]'); } catch (e) { return []; }
  }

  async render() {
    let list = this.read();
    if (this.current) {
      list = list.filter((h) => h !== this.current);
      list.unshift(this.current);
      list = list.slice(0, 12);
      try { localStorage.setItem(this.KEY, JSON.stringify(list)); } catch (e) {}
    }
    const toShow = list.filter((h) => h !== this.current).slice(0, this.limit);
    if (!toShow.length || !this.grid) return;

    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const products = await Promise.all(
      toShow.map((h) => fetch('/products/' + encodeURIComponent(h) + '.js').then((r) => (r.ok ? r.json() : null)).catch(() => null))
    );

    let shown = 0;
    products.forEach((p) => {
      if (!p) return;
      const li = document.createElement('li');
      li.className = 'sk-recent__card';
      const img = p.featured_image || (p.images && p.images[0]) || '';
      const imgUrl = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
      let price = '';
      try { price = (p.price / 100).toLocaleString('nl-NL', { style: 'currency', currency: currency }); } catch (e) { price = (p.price / 100).toFixed(2); }
      const a = document.createElement('a');
      a.className = 'sk-recent__link';
      a.href = '/products/' + p.handle;
      a.innerHTML =
        (imgUrl
          ? '<span class="sk-recent__media"><img class="sk-recent__img" src="' + imgUrl + '" alt="" loading="lazy" width="400" height="400"></span>'
          : '<span class="sk-recent__media"></span>') +
        '<span class="sk-recent__name"></span>' +
        '<span class="sk-recent__price"></span>';
      a.querySelector('.sk-recent__name').textContent = p.title || '';
      a.querySelector('.sk-recent__price').textContent = price;
      const imgEl = a.querySelector('.sk-recent__img');
      if (imgEl) imgEl.alt = p.title || '';
      li.appendChild(a);
      this.grid.appendChild(li);
      shown++;
    });

    if (shown > 0) this.hidden = false;
  }
}

if (!customElements.get('sk-recent-products')) {
  customElements.define('sk-recent-products', SkRecentProducts);
}
